import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerDetailsEditComponent } from './customer-details-edit.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';



@NgModule({
  declarations: [
    CustomerDetailsEditComponent
  ],
  exports: [
    CustomerDetailsEditComponent
  ],
  imports: [
    CommonModule,
    MatExpansionModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule
  ]
})
export class CustomerDetailsEditModule { }
